var map = {
	"./AssignTagTruck.png": 2879,
	"./ZoneMapImageIcon.png": 2880,
	"./assetSummary.png": 2881,
	"./barChart.png": 2882,
	"./battery.png": 2883,
	"./batteryExchange.png": 2884,
	"./batteryLevel.png": 2885,
	"./cages.png": 2886,
	"./deployment.png": 2887,
	"./distribution.png": 2888,
	"./favouriteAssets.png": 2889,
	"./favouritePeople.png": 2890,
	"./favouriteZone.png": 2891,
	"./floorplan.png": 2892,
	"./guage.png": 2893,
	"./hours.png": 2894,
	"./lifecycle.png": 2895,
	"./lineChart.png": 2896,
	"./map.png": 2897,
	"./peopleSummary.png": 2898,
	"./recentItem.png": 2899,
	"./zoneSummary.png": 2900,
	"./zonemap.png": 2901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 651;